import {Calculator} from 'lucide-react'

function Footer() {
  return (
    <footer className="border-t border-white/5 bg-[#05070e]">
      <div className="mx-auto max-w-7xl px-5 py-12">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-center">
          <div className="flex items-center gap-2.5">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-to-br from-indigo-500 to-emerald-400">
              <Calculator className="h-4 w-4 text-[#070a13]" />
            </span>
            <span className="font-display text-base font-bold text-white">
              logo<span className="text-indigo-400">calculators</span>.com
            </span>
          </div>
          <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-slate-400" aria-label="Footer">
            <a href="#pricing" className="hover:text-white">Pricing Estimator</a>
            <a href="#aspect" className="hover:text-white">Aspect Ratio</a>
            <a href="#vans" className="hover:text-white">Vans Formula</a>
            <a href="#galleries" className="hover:text-white">Galleries</a>
            <a href="#guides" className="hover:text-white">Guides</a>
          </nav>
        </div>
        <p className="mt-8 text-xs leading-relaxed text-slate-600">
          © {new Date().getFullYear()} logocalculators.com — The interactive suite of SEO-optimized
          logo calculation tools. Vector design fee, brand identity matrix, and grid-based geometry,
          honoring the Dieter Rams &amp; Braun legacy.
        </p>
      </div>
    </footer>
  )
}

export default Footer
